// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2bO2b","boxTitle":"Qualiphy_boxTitle__2_giS","box":"Qualiphy_box__3Vbz7","toggleWrap":"Qualiphy_toggleWrap__taFw0"};